import { render } from "./Tec-Data.vue?vue&type=template&id=204d5020&scoped=true"
const script = {}

import "./Tec-Data.vue?vue&type=style&index=0&id=204d5020&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-204d5020"]])

export default __exports__